const httpConfig = {
    baseUrl: function () {
        return this.addPrefix("https://casino-apic.bangbet.com");
    }, //https://casino-apic.bangbet.com//192.168.1.166:9998  http://117.78.10.187:7777/ 

    resUrl: "/images/", //"http://117.78.10.187:90/mini/images/", 
    gameUrl: "/game", //"http://39.106.126.249:9977",
    facebookAuth: "https://club.bangbet.com/auth.html",
    facebookAppId: "195254138231933",
    addPrefix: function (url) {
        if (!window.preEvnPrefix || window.preEvnPrefix == "") {
            return url;
        }
        return url.replace("://", ("://" + window.preEvnPrefix));
    },
    AndroidLiteVersion: "1.8",
    nsk: "E6AgEAAkEAno2nAMc3b",
    prefix: "", //api 域名与Path 的前缀
    localResPrefix: "", //本地资源子路径 /rummy
    version: "1.1.25",
    widgetVersion: "1.1.172",
    defaultTimeout: 15000,
    shortRoot: "https://i.bangbet.com",
    sdkVersion: "202001024"
}
export default httpConfig;



// WEBPACK FOOTER //
// ./src/baseConfig/httpConfig/index.js